module.exports = __webpack_public_path__ + "static/media/tm.15d589fd.svg";